import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import NavBar from "./NavBar";


export const PageLayout = (props: {
  children: React.ReactNode;
}): JSX.Element => {
  return (
    <Box height="100vh">
      <Grid
        container
        direction="column"
        wrap="nowrap"
        sx={{ height: "100%" }}
      >
        <Grid item sx={{ mb: 1, width: "100%" }}>
          <NavBar />
        </Grid>
        <Grid item sx={{
          flexGrow: 1,
          overflowY: "auto",
          width: "100%",
          maxHeight: "100%"
        }}>
          {props.children}
        </Grid>
      </Grid>
    </Box>
  );
};
